import { Modal } from "antd";
import React, { memo, useContext, useEffect, useState } from "react";
import {
  MsgError,
  MsgLoading,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import DeleteModal from "../../../components/Modal/DeleteModal";
import Table from "../../../components/Table/Table";
import PkgDestinationCategoriesService from "../../../services/PkgDestinationCategories.service";
import { PkgCategoriesFormFieldsType } from "../../../types/FormFields";
import DeleteAlert from "../../page-essential/DeleteAlert";
import { TravelGuideInputs } from "../TravelGuide/TabAddTravelGuide";
import { transpileModule } from "typescript";
import TranslationForm from "./TranslationForm";
import { IPkgDestinationCategory } from "../../../types/enums/API.types";
import LangContext from "../../../context/LanguageContext";
const tableHeaders = [
  {
    id: 1,
    title: PkgCategoriesFormFieldsType.PACKAGE_TYPE,
  },
  {
    id: 2,
    title: "category_title",
  },
  {
    id: 3,
    title: "packages",
  },
  {
    id: 4,
    img: true,
    title: "img",
  },
];

const TabViewPkgCategories = () => {
  const [data, setData] = useState<IPkgDestinationCategory[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState({
    id: "",
    isFeatured: false,
  });

  const [refreshTable, setRefreshTable] = useState<boolean>(false);
  const [translationModal, setTranslationModal] = useState<boolean>(false);

  const { lang_id } = useContext(LangContext);
  const handleTranslationModal = (id: string) => {
    const indexOfCat = data.findIndex((record) => record.id === id);
    console.log(data[indexOfCat]);
    setActiveCategory({
      id: id,
      isFeatured: data[indexOfCat].isFeatured,
    });
    setTranslationModal(true);
  };

  const handleDelete = async () => {
    try {
      MsgLoading();
      const res = await PkgDestinationCategoriesService.deletePkgDestCat(
        activeCategory.id
      );
      MsgSuccess(res.data.msg);
      setRefreshTable(!refreshTable);
      setIsDeleteModalOpen(false);
    } catch (error: any) {
      console.log(error);
      MsgError(error.response.data.msg || "Can not delete this item !");
    }
  };
  const handleDeleteModal = (id: string) => {
    setActiveCategory({
      id: id,
      isFeatured: false,
    });
    setIsDeleteModalOpen(true);
  };

  const actionPrps = {
    handleDelete: handleDeleteModal,
    translation: handleTranslationModal,
  };
  useEffect(() => {
    MsgLoading();
    PkgDestinationCategoriesService.getAllPkgDestCat()
      .then((res) => {
        const d = res.data.data as IPkgDestinationCategory[];
        interface iType extends IPkgDestinationCategory {
          [key: string]: any;
        }
        const newData = d.map((item: iType) => {
          const filteredTranslation = item.translations.find(
            (item) => item.lang_id.id === (lang_id as any)
          );
          item["category_title"] = filteredTranslation?.category_title;
          return item;
        });
        setData(newData);
        MsgSuccess(res.data.msg);
      })
      .catch((err: any) => {
        MsgError(err.response.data.msg);
      });
  }, [refreshTable, lang_id]);

  return (
    <div>
      <h2 className="text-xl">Package Destination Categories</h2>
      <p>{data?.length}</p>

      <div className="my-5">
        <Table
          tableHeaders={tableHeaders}
          tableBody={data}
          actions={actionPrps}
        />
      </div>
      {/* delete Modal  */}
      <DeleteModal
        title="delete "
        isDeleteModalOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        handleDelete={handleDelete}
      />
      {translationModal ? (
        <Modal
          open={translationModal}
          title={null}
          keyboard
          onCancel={() => setTranslationModal(false)}
          footer={null}
        >
          {" "}
          <div className="text-gray-500">
            <h2 className="font-bold">Add Package category translation</h2>
          </div>
          <TranslationForm
            category_id={activeCategory.id}
            featuredCagtegory={activeCategory.isFeatured}
          />
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(TabViewPkgCategories);
